import { createAction } from '@ngrx/store';
/**
 * Actions to patch the form values in daily allowance store
 * from existing patient, lastConsultation or renal detect recommendation
 */
export const setDailyAllowanceFormValues = createAction('[Daily Allowance] Set Form Values');
